<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Programaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Flota">Planta Externa</router-link>
                  </li>
                  <li class="breadcrumb-item active">Programaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="btn-group shadow float-right">
                  <button
                    type="button"
                    class="btn bg-gradient-navy"
                    @click="getIndex()"
                  >
                    <i class="fas fa-sync-alt fa-spin"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="limpiarFiltros()"
                  >
                    <i class="fas fa-broom"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="create()"
                    v-if="$store.getters.can('plantaEx.progrmacion.create')"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm text-center text-nowrap"
                >
                  <thead>
                    <tr>
                      <th>
                        Nombre
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @change="getIndex()"
                        />
                      </th>
                      <th>
                        Solicitante
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.solicitante"
                          @change="getIndex()"
                        />
                      </th>
                      <th>
                        Fecha
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha"
                          @input="getIndex()"
                        />
                      </th>
                      <th>
                        Bloque
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="filtros.bloque"
                          :options="listasForms.bloques"
                          label="nombre"
                          :reduce="(item) => item.id"
                          @input="getIndex()"
                        />
                      </th>
                      <th class="text-center">
                        Observaciones
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.observacion"
                          @change="getIndex()"
                        />
                      </th>
                      <th>
                        Estado
                        <select
                          v-model="filtros.estado"
                          @change="getIndex()"
                          class="form-control form-control-sm"
                        >
                          <option value="">Todos..</option>
                          <option
                            v-for="estado in listasForms.estados"
                            v-bind:key="estado.id"
                            v-bind:value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th
                        class="align-middle"
                        v-if="
                          $store.getters.can('plantaEx.progrmacion.edit') &&
                            $store.getters.can('plantaEx.progrmacion.delete')
                        "
                      >
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(programacion, index) in programaciones.data"
                      :key="index"
                    >
                      <td>{{ programacion.nombre }}</td>
                      <td>{{ programacion.user?.name }}</td>
                      <td>
                        {{ programacion.fecha }}
                      </td>
                      <td>
                        {{ programacion.bloque?.nombre }}
                      </td>
                      <td>{{ programacion.observaciones }}</td>
                      <td class="text-center">
                        <span
                          class="badge shadow"
                          :class="
                            programacion.estado == 1
                              ? 'badge-warning'
                              : 'badge-success'
                          "
                        >
                          {{ programacion.nEstado ? programacion.nEstado : "" }}
                        </span>
                      </td>
                      <td
                        v-if="
                          $store.getters.can('plantaEx.progrmacion.edit') &&
                            $store.getters.can('plantaEx.progrmacion.delete')
                        "
                      >
                        <div class="btn-group shadow-sm">
                          <button
                            type="button"
                            class="btn btn-sm bg-gradient-navy"
                            @click="edit(programacion)"
                            v-if="
                              $store.getters.can('plantaEx.progrmacion.edit')
                            "
                          >
                            <i class="fas fa-edit"></i>
                          </button>

                          <button
                            type="button"
                            class="btn btn-sm bg-gradient-danger"
                            @click="destroy(programacion.id)"
                            v-if="
                              $store.getters.can(
                                'plantaEx.progrmacion.delete',
                              ) && programacion.estado == 1
                            "
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="programaciones.total">
                  <p>
                    Mostrando del <b>{{ programaciones.from }}</b> al
                    <b>{{ programaciones.to }}</b> de un total:
                    <b>{{ programaciones.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="programaciones"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";

export default {
  name: "PlantProgramacionIndex",
  components: {
    vSelect,
    loading,
    pagination,
  },
  data() {
    return {
      cargando: false,
      programaciones: {},
      filtros: {},
      listasForms: {
        estados: [],
        bloques: [],
      },
    };
  },

  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/plant/programaciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.programaciones = response.data;
          this.cargando = false;
        });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getBloques() {
      axios.get("/api/plant/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    destroy(id) {
      this.$swal({
        title: "Esta seguro de eliminar la Programación: " + id + "?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios.delete("/api/plant/programaciones/" + id).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el item exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    limpiarFiltros() {
      this.filtros = {};
      this.getIndex();
    },

    create() {
      return this.$router.push({
        name: "/plantaExterna/programacionForm",
        params: { accion: "Crear", id: null },
      });
    },

    edit(programacion) {
      return this.$router.push({
        name: "/plantaExterna/programacionForm",
        params: {
          accion: "Editar",
          data_edit: programacion,
          id: programacion.id,
        },
      });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.getBloques();
  },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.edit {
  display: none;
}
.editing .edit {
  display: block;
}
.editing .view {
  display: none;
}
</style>
